import "../styles/Home.css";
// import { CiMenuFries } from "react-icons/ci";
import Ourservices from './Ourservices';
import About from './Aboutus';
import Ourplan from './Ourplan';
import Footer from './Foooter';
import OurManuFacturing from './OurManuFacturing';
import OurkeyInd from "./OurkeyInd";
import ImageSlider from "./ImageSlider";

const Home = () => {
    return (
        <>
        <ImageSlider />
            <div className="main">
                <div className="home-page">
                    <div className="home1">
                        <div className="h1">
                            <h4 className="build">Innovating for a Better Tomorrow Empowering</h4>
                            <h4 className="dream">  </h4>
                            <h3 className="fat"> Businesses with cutting-edge technology solutions.</h3>
                            <p id="para"> where we revolutionize businesses around the globe with cutting-edge technology solutions. As trailblazers in innovation, our vision is to shape a future where technology enhances and enriches every aspect of life. With an unwavering commitment to excellence, our mission is to turn bold ideas into extraordinary realities. Join us as we embark on a journey to transform the future, one groundbreaking solution at a time.</p>
                            {/* <buttton className="join-but" variant="contained">Join</buttton> */}
                        </div>
                        <div className="h2">
                        </div>
                    </div>
                </div>
                <About />
                <Ourservices />
                <OurkeyInd />
                <OurManuFacturing />
                <Ourplan />
                <Footer />
            </div>
        </>
    );
}

export default Home;